import superagent from 'superagent'

function dawaAutocomplete (query, $store) {
  return superagent
    .get('https://dawa.aws.dk/adresser/autocomplete')
    .query({q: query, postnr: $store.state.user.postalCode, vejnavn: $store.state.user.streetName, per_side: 100})
    .accept('json')
}

export {dawaAutocomplete}



// WEBPACK FOOTER //
// ./src/utils/dawaAutocomplete.js